import CommonLink from 'components_v2/CommonLink'
import React from 'react'

const TagsContainer = ({ tags = [] }) => {
  return (
    <>
      {tags?.length > 0 && (
        <div className='plan-works-on'>
          {tags
            ?.filter((t) => t?.tags?.length > 0)
            .map((tg) => (
              <div key={tg.key} className='context-tags-container'>
                <h4>{tg.title}</h4>
                <ul className='tags-list'>
                  {tg?.tags.map((k) => (
                    <li key={k}>
                      <CommonLink to={`/tags/${k}`}>{k}</CommonLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </div>
      )}
    </>
  )
}

export default TagsContainer
